import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import ContactSubTypes from "const/ContactSubTypes";
import React, { useMemo } from "react";
import Select from "nlib/ui/Select";

const ContactFormSubTypeSelect = ({ ...restProps }) => {
  const { uiTexts } = useSelector(getTextsData);

  const options = useMemo(() => {
    return [
      ...Object.values(ContactSubTypes)
        .map((type) => ({
          value: type,
          label: uiTexts[type]
        })),
      { value: null, label: uiTexts.all }
    ];
  }, [uiTexts]);

  return (
    <Select
      placeholder={uiTexts.selectType}
      options={options}
      {...restProps} />
  );
};

export default React.memo(ContactFormSubTypeSelect);
